import React, { Component } from 'react'
import { Menu, Dropdown, Button } from 'antd'
import { ClusterOutlined, DownOutlined } from '@ant-design/icons'
import { messageTypes } from '../../actions/messages'
import { connect } from 'react-redux'
import config from '../../config'

class StackActionDropdown extends Component {
  render () {
    const { stack, disabled, language, executeStackAction } = this.props

    const menu = (
      <Menu>
        <Menu.Item
          key='revert'
          onClick={() => executeStackAction(stack._id, 'revert')}
        >
          <span>{messageTypes[language].revert_and_poweroff_stack}</span>
        </Menu.Item>
        {!config.disable_revert_and_power_on && (
          <Menu.Item
            key='revert-with-poweron'
            onClick={() => executeStackAction(stack._id, 'revert-with-poweron')}
          >
            <span>{messageTypes[language].revert_and_poweron_stack}</span>
          </Menu.Item>)}
        <Menu.Item
          key='revert-with-powerff-machines'
          onClick={() => executeStackAction(stack._id, 'revert-with-poweroff-machines')}
        >
          <span>{messageTypes[language].revert_and_poweroff_machines}</span>
        </Menu.Item>
      </Menu>
    )

    return (
      stack !== 'switching'
        ? (
          <Dropdown overlay={menu} disabled={disabled}>
            <Button>
              <ClusterOutlined /> {messageTypes[language].current_stack} <DownOutlined />
            </Button>
          </Dropdown>
          )
        : false
    )
  }
}

const mapStateToProps = state => ({
  stack: state.hdStore.stack
})

const StackActionDropdownContainer = connect(
  mapStateToProps
)(StackActionDropdown)

export default StackActionDropdownContainer
